import ContentEditable from "react-contenteditable"
import { useEffect } from "react"

const ResizableContentEditable = ({ html, onChange, className, classNameContentEditable, innerRef }) => {

  const handleChange = (event) => {
    innerRef.current.style.height = 'auto';
    innerRef.current.style.height = (innerRef.current.scrollHeight) + 'px';
    onChange(event);
  };

  useEffect(() => {
    innerRef.current.style.height = 'auto';
    innerRef.current.style.height = (innerRef.current.scrollHeight) + 'px';
  }, [html])

  return (
    <div className={className}>
      <ContentEditable html={html} className={classNameContentEditable} onChange={handleChange} innerRef={innerRef} />
    </div>
  );
};

export default ResizableContentEditable;
